import { __assign, __rest } from "tslib";
import { Container, StyledInput, SubTitle, Title } from "./styles";
import ReactInputMask from "react-input-mask";
import { Input } from "reactstrap";
import React, { useState } from "react";
var DefaultInput = function (_a) {
    var color = _a.color, width = _a.width, title = _a.title, subtitle = _a.subtitle, style = _a.style, inputStyle = _a.inputStyle, containerStyles = _a.containerStyles, titleStyles = _a.titleStyles, onChange = _a.onChange, value = _a.value, placeholder = _a.placeholder, mask = _a.mask, disabled = _a.disabled, name = _a.name, defaultValue = _a.defaultValue, type = _a.type, rest = __rest(_a, ["color", "width", "title", "subtitle", "style", "inputStyle", "containerStyles", "titleStyles", "onChange", "value", "placeholder", "mask", "disabled", "name", "defaultValue", "type"]);
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    return (React.createElement(Container, { width: width, style: containerStyles },
        title && React.createElement(Title, { style: titleStyles }, title),
        subtitle && React.createElement(SubTitle, null, subtitle),
        React.createElement(StyledInput, { color: color, style: style, focused: focused ? "true" : "false", disabled: disabled ? "true" : "false" }, mask ? (React.createElement(ReactInputMask, { name: name, mask: mask, maskPlaceholder: null, value: value, onChange: function (e) {
                if (onChange) {
                    onChange(e);
                }
            }, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, defaultValue: defaultValue, disabled: disabled },
            React.createElement(Input, __assign({}, rest, { type: type, placeholder: placeholder })))) : (React.createElement(Input, __assign({ name: name, disabled: disabled, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, style: inputStyle, placeholder: placeholder, onChange: function (e) {
                if (onChange) {
                    onChange(e);
                }
            }, value: value, defaultValue: defaultValue, type: type }, rest))))));
};
DefaultInput.defaultProps = {
    color: "#cdcdcd",
    width: undefined,
    title: undefined,
    subtitle: undefined,
    style: undefined,
    inputStyle: undefined,
    placeholder: "",
    containerStyles: undefined,
    mask: undefined,
    onChange: function () { },
    disabled: false,
    name: undefined
};
export default DefaultInput;
//# sourceMappingURL=index.js.map